<script>
  const year = new Date().getFullYear()
</script>

<style>
  footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 95px;
    margin: 100px 0 50px;
    padding-bottom: 50px;
  }

  .l-social-media {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 280px;
  }
  .copyright {
    font-size: 14px;
    color: #1b222580;
    letter-spacing: 0.4px;
  }
  @media only screen and (max-width: 1024px) {
    footer {
      margin: 50px 0;
    }
  }
  @media only screen and (max-width: 640px) {
    .l-social-media {
      width: 219px;
    }
    .copyright {
      font-size: 12px;
    }
  }
</style>

<footer>
  <div class="l-social-media">

    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://twitter.com/caseycrawford">
      <img src="images/twitter.svg" alt="twitter" />
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.instagram.com/caseyscrawford/">
      <img src="images/instagram.svg" alt="instagram" />
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.facebook.com/CaseyCrawfordMovement/">
      <img src="images/facebook.svg" alt="facebook" />
    </a>

    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.linkedin.com/in/caseycrawford/">
      <img src="images/linkedin.svg" alt="linkedin" />
    </a>

  </div>
  <div class="copyright">
    &copy; {year} Casey Crawford, All rights reserved.
  </div>
</footer>
